const MoneyFormater = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
});

export const MakeMoneyValue = ({ value }) => {
  //console.log('this is my money value ---> ', MoneyFormater.format(value));
  return MoneyFormater.format(value);
};
